export default {
    data () {
        return {}
    },
    mounted() {
        /*
            ["System", "Products", "Purchase", "Sales", "Stocks", "Materials", 
            "System.Config", "System.RoleManage", "System.AdminManage", "System.LoginLogs", "System.HandleLogs", 
            "Products.CategoryManage", "Products.BrandManage", "Products.ProductView", "Products.ProductCostView", 
            "Products.ProductCreate", "Products.ProductUpdate", "Products.ProductPriceUpdate", "Products.ProductDelete", 
            "Purchase.View", "Purchase.OrderCreate", "Purchase.OrderUpdate", "Purchase.OrderDelete", "Purchase.OrderStockPutIn", 
            "Sales.View", "Sales.OrderCreate", "Sales.OrderUpdate", 
            "Sales.OrderAudit", "Sales.OrderReceiveMoney", "Sales.OrderDelete", "Sales.OrderStockTakeOut", 
            "Stocks.Inventory", "Stocks.BillManage", "Stocks.SerialNumberManage", "Stocks.PutIn", 
            "Stocks.TakeOut", "Stocks.PurchaseReturn", "Stocks.SaleReturn", "Stocks.SaleExchange", "Stocks.ChangeLogs", 
            "Stocks.SerialNumberLogs", "System.WarehouseManage"]
        */
        // console.error(this.$store.getters.roles)
    },
    computed: {
        /* ----------管理---------- */
        isSystem() {
            return this.hasSpecialRole("System.System")
        },
        isSystemConfig() {
            return this.hasSpecialRole("System.System.SystemConfig")
        },
        isSystemAuditLog() {
            return this.hasSpecialRole("System.System.AuditLog")
        },
        isSystemSpider() {
            return this.hasSpecialRole("System.Spider")
        },
        isSystemSpiderRun() {
            return this.hasSpecialRole("System.Spider.Run")
        },
        
        /* ----------身份角色，用户管理---------- */
        isAbpIdentity() {
            // 是否有身份大类权限
            return this.hasSpecialRole("AbpIdentity")
        },
        isRolesManage() {
            // 是否可以角色管理
            return this.hasSpecialRole("AbpIdentity.Roles")
        },
        isRolesCreate() {
            return this.hasSpecialRole("AbpIdentity.Roles.Create")
        },
        isRolesUpdate() {
            return this.hasSpecialRole("AbpIdentity.Roles.Update")
        },
        isRolesDelete() {
            return this.hasSpecialRole("AbpIdentity.Roles.Delete")
        },
        isRolesPermissions() {
            return this.hasSpecialRole("AbpIdentity.Roles.ManagePermissions")
        },
        isUsersManage() {
            // 是否可以用户管理
            return this.hasSpecialRole("AbpIdentity.Users")
        },
        isUsersCreate() {
            return this.hasSpecialRole("AbpIdentity.Users.Create")
        },
        isUsersUpdate() {
            return this.hasSpecialRole("AbpIdentity.Users.Update")
        },
        isUsersManageRoles() {
            return this.hasSpecialRole("AbpIdentity.Users.Update.ManageRoles")
        },
        isUsersDelete() {
            return this.hasSpecialRole("AbpIdentity.Users.Delete")
        },
        isUsersPermissions() {
            return this.hasSpecialRole("AbpIdentity.Users.ManagePermissions")
        },

        /* ----------基础数据---------- */
        isBaseData() {
            // 是否有基础数据大类权限
            return this.hasSpecialRole("BaseData.BaseData")
        },
        isBaseDataView() {
            return this.hasSpecialRole("BaseData.BaseData.View")
        },
        isBaseDataImport() {
            return this.hasSpecialRole("BaseData.BaseData.Import")
        },

        /* ----------运维数据---------- */
        isOperation() {
            // 是否有运营数据大类权限
            return this.hasSpecialRole("Operation.Operation")
        },
        isOperationMoveTask() {
            return this.hasSpecialRole("Operation.Operation.MoveTask")
        },
        isOperationMoveTaskAudit() {
            return this.hasSpecialRole("Operation.Operation.MoveTaskAudit")
        },
        isOperationBatteryChangeTask() {
            return this.hasSpecialRole("Operation.Operation.BatteryChangeTask")
        },
        isOperationBatteryChangeTaskAudit() {
            return this.hasSpecialRole("Operation.Operation.BatteryChangeTaskAudit")
        },
        isOperationMaintenanceLog() {
            return this.hasSpecialRole("Operation.Operation.MaintenanceLog")
        },
        isOperationMaintenanceLogAudit() {
            return this.hasSpecialRole("Operation.Operation.MaintenanceLogAudit")
        },
        isOperationCustomerArea() {
            return this.hasSpecialRole("Operation.Operation.CustomerArea")
        },
        isOperationCustomerAreaConfig() {
            return this.hasSpecialRole("Operation.Operation.CustomerAreaConfig")
        },
        isOperationTravel() {
            return this.hasSpecialRole("Operation.Operation.Travel")
        },

        /* ----------分析数据---------- */
        isAnalysisVehicleAnalysis() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis")
        },
        isAnalysisVehicleLostOrderAnalysis() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.LostOrderAnalysis")
        },
        isAnalysisVehicleLogs() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleLogs")
        },
        isAnalysisVehicleLastLocation() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleLastLocation")
        },
        isAnalysisVehicleList() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleList")
        },
        isAnalysisVehicleDataImport() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleDataImport")
        },
        isAnalysisVehiclePolicyManage() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehiclePolicyManage")
        },
        isAnalysisVehicleChassisManage() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleChassisManage")
        },
        isAnalysisVehicleControlManage() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleControlManage")
        },
        isAnalysisVehicleInsuranceQuery() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleInsuranceQuery")
        },
        isAnalysisVehicleInsuranceExport() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleInsuranceExport")
        },
        isAnalysisVehicleDataOverview() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleDataOverview")
        },
        isAnalysisVehicleDataChangeLog() {
            return this.hasSpecialRole("DataAnalysis.VehicleAnalysis.VehicleDataChangeLog")
        },

        isAnalysisReport() {
            return this.hasSpecialRole("DataAnalysis.Report")
        },
        isAnalysisReportView() {
            return this.hasSpecialRole("DataAnalysis.Report.ReportView")
        },
        isAnalysisReportCreate() {
            return this.hasSpecialRole("DataAnalysis.Report.ReportCreate")
        },
        isAnalysisReportUpdate() {
            return this.hasSpecialRole("DataAnalysis.Report.ReportUpdate")
        },
        isAnalysisReportDelete() {
            return this.hasSpecialRole("DataAnalysis.Report.ReportDelete")
        },

        isAnalysis() {
            return this.hasSpecialRole("DataAnalysis.Analysis")
        },
        isAnalysisDashboard() {
            return this.hasSpecialRole("DataAnalysis.Analysis.Dashboard")
        },
        isAnalysisUser() {
            return this.hasSpecialRole("DataAnalysis.Analysis.User")
        },
        isAnalysisVehicle() {
            return this.hasSpecialRole("DataAnalysis.Analysis.Vehicle")
        },
        isAnalysisVehicleHeatMap() {
            return this.hasSpecialRole("DataAnalysis.Analysis.VehicleHeatMap")
        },
        isAnalysisVehicleRealTimeAnalysis() {
            return this.hasSpecialRole("DataAnalysis.Analysis.VehicleRealTimeAnalysis")
        },
        isAnalysisOrderAnalysis() {
            return this.hasSpecialRole("DataAnalysis.Analysis.OrderAnalysis")
        },

        isEmployee() {
            return this.hasSpecialRole("Employee.Employee")
        },
        isEmployeeWorkConfig() {
            return this.hasSpecialRole("Employee.Employee.EmployeeWorkConfig")
        },
        isEmployeeWork() {
            return this.hasSpecialRole("Employee.Employee.EmployeeWork")
        },
        isEmployeeInsurance() {
            return this.hasSpecialRole("Employee.Employee.EmployeeInsurance")
        },
        isEmployeeArchive() {
            return this.hasSpecialRole("Employee.Employee.EmployeeArchive")
        },
        isEmployeeArchiveManage() {
            return this.hasSpecialRole("Employee.Employee.EmployeeArchiveManage")
        },
    },
    methods: {
        // 传递权限名称，返回是否存在
        isHasPermission(roleName) {
            let index = this.$store.getters.roles.findIndex(role => {
                role = role.replace(".", "")
                roleName = roleName.replace(".", "")
                return role == roleName
            })
            return index != -1
        },
        // 判断是否有指定权限
        hasSpecialRole(role) {
            return this.$store.getters.roles.indexOf(role) != -1
        }
    }
  }
  
  
  